import {VariantConfigT} from '@/lib/types/colors.types';

export const darkConfig: VariantConfigT = {
  basic: {
    icon: 'dark',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'dark',
    active: 'dark',
  },
  outline: {
    icon: 'dark',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'dark',
    iconHover: 'dark',
    iconActive: 'dark',
    hover: 'dark',
    active: 'dark',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
